<template>

  <div style="margin: -15px -15px; background-color: #f0f2f5">
    <!-- tag查询框 -->
    <div class="datePicker">
      <div class="date">
        APP版本号：
        <a-input
          style="width: 180px; margin-right: 20px"
          placeholder="请输入"
          v-model="searchName"
          @keyup.enter="searchBtn"
        ></a-input>
      </div>
      <div style="display: flex; align-items: center; margin-right: 50px">
        <span>创建日期</span>: &nbsp;
        <a-range-picker v-model="timeVal" style="width: 220px" @change="onChange_range_picker" />
      </div>
      <a-button type="primary" style="margin-left: 30px" @click="searchBtn"
        >查询</a-button
      >
      <!-- @click="returnBtn" -->
      <a-button style="margin-left: 15px; margin-right: 40px" @click="returnBtn"
        >重置</a-button
      >
    </div>
    <div style="background-color: #fff; padding: 20px; padding-bottom: 80px">
      <a-button
        type="primary"
        style="margin-bottom: 20px; margin-right: 3%"
        @click="newlyBuilt"
      >
        新增
      </a-button>
      <a-table
        :columns="columns"
        style="min-height: 500px; background-color: #fff"
        :data-source="dataTable"
        :rowKey="(record) => record.id"
        :pagination="false"
        :scroll="{ x: 1800 }"

      >
        <span slot="operate" slot-scope="text, item, index">
          <a @click="windowOpen(item.downloadUrl)" style="margin-right: 10px">下载</a>
          <a @click="editBtn(item.id, item)" style="margin-right: 10px">编辑</a>
          <a-popconfirm
            title="确定删除?"
            ok-text="是"
            cancel-text="否"
            @confirm="delBtn(item.id)"
          >
            <a style="margin-right: 10px">删除</a>
          </a-popconfirm>
        </span>
        <span slot="changeJia" slot-scope="text, record, item, id">
          <a-switch
            @change="onChange(record.id, record.status === 'OPENED' ? 'CLOSED' : 'OPENED')"
            :checked="record.status !== 'CLOSED'"
            checked-children="是"
            un-checked-children="否"
            default-checked
          />
        </span>
        <span slot="TheType" slot-scope="text, record, item, id">
          {{ record.type === 'ANDROID' ? '安卓' : 'IOS' }}
        </span>
        <span slot="isTheForce" slot-scope="text, record, item, id">
          <a-switch
            @change="on2Change(record.id, record.isForced === 1 ? 0 : 1)"
            :checked="record.isForced !== 0"
            checked-children="是"
            un-checked-children="否"
            default-checked
          />
        </span>
        <span slot="releaseNotes" slot-scope="text, record, item, id">
          <span v-html="record.releaseNotes"></span>
        </span>
      </a-table>
      <!-- 新建的表单 -->
      <a-drawer
        title="新增/编辑"
        placement="right"
        :closable="false"
        :visible="addShow"
        @close="addCancel"
        width="40%"
      >
        <a-spin :spinning="spinning" style="z-index: 1">
        <a-form-model
          :model="addForm"
          :label-col="labelCol"
          :rules="rules"
          :wrapper-col="wrapperCol"
          ref="add"
        >
          <a-form-model-item prop="versionName" label="APP版本号">
            <a-input
              v-model="addForm.versionName"
              auto-size
              placeholder="请输入"
            />
          </a-form-model-item>
          <a-form-model-item prop="versionCode" label="版本code">
            <a-input
              v-model="addForm.versionCode"
              auto-size
              placeholder="请输入"
            />
          </a-form-model-item>
          <a-form-model-item prop="type" label="系统">
            <a-radio-group name="radioGroup" v-model="addForm.type" @change="changeType">
              <a-radio value="ANDROID">
                安卓
              </a-radio>
              <a-radio value="IOS">
                IOS
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="apk包" prop="downloadUrl" required v-if="addForm.type != 'IOS'">
            <div class="upload_File">
              <input style=" cursor:pointer;width:100%;height: 100%;opacity: 0;" ref="addFile" type="file"  @change="addFile"  />
            </div>
            <span style="font-size: xx-small">{{addForm.downloadUrl}}</span>
          </a-form-model-item>
          <a-form-model-item prop="hint" label="更新标题">
            <a-input
              v-model="addForm.hint"
              auto-size
              placeholder="请输入"
            />
          </a-form-model-item>
          <a-form-model-item prop="releaseNotes" required label="更新内容">
            <a-textarea v-model="addForm.releaseNotes" auto-size style="min-height: 100px;font-size: 16px"/>
            
            <!-- <div
              v-if="addShow == true"
              style="border: 1px solid #ccc; min-height: 400px; width: 450px"
            >
              <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"
              />
              <Editor
                style="overflow-y: hidden"
                v-model="addForm.releaseNotes"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
              />
            </div> -->
          </a-form-model-item>
          <a-form-model-item label="是否开启" required>
            <a-switch checked-children="开" un-checked-children="关" v-model="addForm.status" @change="addStatus"/>
          </a-form-model-item>
          <a-form-model-item label="是否强制更新" required>
            <a-switch checked-children="开" un-checked-children="关" v-model="addForm.isForced" @change="addForced"/>
          </a-form-model-item>
          <div style="height: 100px;"></div>
        </a-form-model>
        </a-spin>
       <div
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-button
            :style="{ marginRight: '8px' }"
            @click="
              () => {
                this.addShow = false;
                this.$refs.add.resetFields();
                this.addForm = {}
              }
            "
          >
            取消
          </a-button>
                      <!-- v-if="buttonType == 'newBuild'" -->
          <a-button
            :style="{ marginRight: '8px' }"
            type="primary"
            @click="addOk()"
          >
            确定
          </a-button>
                      <!-- v-if="buttonType == 'newBuild'" -->
          <!-- <a-button
            :style="{ marginRight: '8px' }"
            type="primary"
            @click="editOk()"
          > -->
                      <!-- v-if="buttonType == 'edit'" -->
            <!-- 确定
          </a-button> -->
       </div>
      </a-drawer>
      <!-- table框的分页 -->
      <div
        style="
          margin-top: 28px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span
          style="font-size: medium; color: #929292; font-size: 14px; bottom: 3%"
        >
          共{{ pagination.total }}条记录 第 {{ pagination.pageNum }} /
          {{ Math.ceil(pagination.total / pagination.pageSize) }} 页
        </span>
        <a-pagination
          style="float: right"
          show-quick-jumper
          show-size-changer
          :page-size.sync="pagination.pageSize"
          :total="pagination.total"
          v-model="pagination.current"
          @change="pageChange"
          @showSizeChange="pageChange"
        />
      </div>
    </div>
  </div>
  </a-spin>
</template>

<script>
// import {
//      postExpertFile
// } from "@/service/zoomMeet_api";
import {
  getVersion,postExpertFile,postVersion,putVersion,delVersion
} from "@/service/VersionUpdate";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import axios from "axios";
const editorConfig = {
  // JS 语法
  MENU_CONF: {},
};
const signature = "";
// 修改 uploadImage 菜单配置
editorConfig.MENU_CONF["uploadImage"] = {
  // 自定义上传
  async customUpload(file, insertFn) {
    let formData = new FormData();
    formData.append("file", file);
    // file 即选中的文件,自己实现上传，并得到图片 url alt href
    axios
      .post(
        "https://yun-new-admin-api.yunicu.com/api/admin/common/update",
        formData
      )
      .then((res) => {
        if (res.data.code === 0) {
          insertFn(res.data.data.url); // 最后插入图片
        }
      });
  },
};
// 修改 uploadVideo 菜单配置
editorConfig.MENU_CONF["uploadVideo"] = {
  // 自定义上传
  async customUpload(file, insertFn) {
    let mediaFile = file;
    //获取签名
    axios
      .get("https://yun-new-admin-api.yunicu.com/v3/getUgcUploadSign")
      .then((res) => {
        if (res.data.code === 0) {
          const getSignature = () => {
            return res.data.data.signature;
          };
          const tcVod = new TcVod({
            getSignature: getSignature, //上传签名的函数
          });
          const uploader = tcVod.upload({
            mediaFile: mediaFile, // 媒体文件（视频或音频或图片），类型为 File
          });
          uploader.done().then((res) => {
            insertFn(res.video.url); // 进行视频处理：转码和截图
          });
        }
      });
  },
};
export default {
  components: { Editor, Toolbar },
  data() {
    return {
      mode: "default", // or 'simple'
      spinning:false,
      editorConfig,
      editor: null,
      settingEditor: null,
      settingHtml: "",
      toolbarConfig: {},
      searchName: "",
      state: "",
      startTime: "",
      endTime: "",
      addForm: {
        releaseNotes: "",
      },
      dataTable: [],
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      timeVal:[],//日期
      pagination: {
        //存储大table的分页
        total: 0,
        current: 1,
        pageSize: 10,
        pageNum: 1,
      },
      rules: {
        versionName: [{ required: true, message: "请输入", trigger: "blur" }],
        versionCode: [{ required: true, message: "请输入", trigger: "blur" }],
        hint: [{ required: true, message: "请输入", trigger: "blur" }],
        downloadUrl: [{ required: true, message: "请上传", trigger: "change" }],
        type: [{ required: true, message: "请选择", trigger: "change" }],
        releaseNotes: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      columns: [
        {
          title: "APP版本号",
          dataIndex: "versionName",
          key: "versionName",
          //    align:'center',
          //    width:'20%',
        },
        {
          title: "版本code",
          dataIndex: "versionCode",
          key: "versionCode",
          align: "center"
        },
        {
          title: "系统",
          dataIndex: "type",
          key: "type",
          align: "center",
          scopedSlots: { customRender: "TheType" },
        },
        {
          title: "是否开启",
        //   dataIndex: "createdTime",
        //   key: "createdTime",
        //   align: "center",
        //   scopedSlots: { customRender: "addTime" },
          scopedSlots: { customRender: "changeJia" },
        },
        {
          title: "是否强制更新",
        //   dataIndex: "createdTime",
        //   key: "createdTime",
        //   align: "center",
        //   scopedSlots: { customRender: "addTime" },
          scopedSlots: { customRender: "isTheForce" },
        },
        {
          title: "更新标题",
        //   width:'15%',
          align: "center",
          dataIndex: "hint",
        },
        {
          title: "更新内容",
          width:'25%',
        //   align: "center",
          dataIndex: "releaseNotes",
          scopedSlots: { customRender: "releaseNotes" },
        },
        {
          title: "更新人",
          // width:'15%',
        //   align: "center",
          dataIndex: "createdByName",
        },
        {
          title: "更新时间",
          width:'15%',
        //   align: "center",
          dataIndex: "updatedTime",
        },
        {
          title: "创建时间",
          width:'15%',
        //   align: "center",
          dataIndex: "createdTime",
        },
        {
          title: "操作",
          width: "180",
          fixed: "right",
          scopedSlots: { customRender: "operate" },
        },
      ],
      StartTime: "",
      EndTime: "",
      addShow: false,

    }
  },
  created() {
    this.getTable();
  },
  methods: {
    changeType() {
      if (this.addForm.type == 'IOS') {
        this.addForm.downloadUrl = ''
      }
    },
    addStatus (e) { // 新增页面中的状态按钮打开关闭方法
      // this.addForm.isOpen === 1 ? this.addForm.isOpen = 0 : this.addForm.isOpen = 1
      this.addForm.status = e
    },
    addForced (e) { // 新增页面中的状态按钮打开关闭方法
      this.addForm.isForced = e
    },
    async addFile(){
      this.spinning = true
      let inputDOM = this.$refs.addFile.files[0];
      let formData = new FormData()
      formData.append('file', inputDOM)
      const add = await postExpertFile(formData)
      if (add.code === 0) {
        // this.$set(this.addForm,'downloadUrl',add.data[0])
        // console.log(1111,add)
        this.$set(this.addForm,'downloadUrl',add.data)
        // this.$set(this.accessorForm,'name',inputDOM.name)
        // this.$refs.addFile.value=null
        this.$message.success('上传成功')
      } else {
        this.$message.error("上传失败");
      }
      this.spinning = false
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    // 弹窗取消
    addCancel() {
      this.$refs.add.resetFields();
      this.addShow = false;
       this.addForm = {}
    //   this.btnContentType = "save";
    //   this.btnType = "save";
    },
    // 新建表单
    newlyBuilt() {
      this.addShow = true;
    //   this.addForm.releaseNotes = "";
    //   this.addForm.drugName = "";
      // this.getIndex(this.index)
      // this.getVideoIndex(this.VideoIndex)
      // console.log("看看新建的form", this.form)
    //   this.buttonType = "newBuild";
      // this.startTime = (moment().format('YYYY-MM-DD'))
    },
    // 点击修改
    async editBtn(id, item) {
    //   //   this.$set(this.editForm, 'title', item.catalogue)
    // console.log("????",item)
      this.addShow = true; //注意渲染先后顺序，要先打开表单再执行接口
    //   this.id = id;
      this.onCreated();
      // item.isForced == 1 ? this.addForm.isForced = true : this.addForm.isForced = false
      // item.status == 1 ? this.addForm.status = true : this.addForm.status = false
      this.addForm = JSON.parse(JSON.stringify(item));
      this.addForm.isForced = item.isForced == 1 ? true : false
      this.addForm.status = item.status == 'OPENED' ? true : false

    //   this.buttonType = "edit";
    //   const Info = await getDrugsById(id);
    //   if (Info.code === 0) {
    //     // console.log("单条数据",Info)
    //     this.addForm = JSON.parse(JSON.stringify(Info.data));
    //     // 需要添加id放到两个表里面
    //     // detail表
    //     var data = [];
    //     data = Info.data.detail;
    //     for (var i = 0; i < Info.data.detail.length; i++) {
    //       let key = "id";
    //       data[i][key] = i;
    //     }
    //     this.addForm.detail = data;

    //     // content表
    //     var contentData = [];
    //     contentData = Info.data.content;
    //     for (var i = 0; i < Info.data.content.length; i++) {
    //       let key = "id";
    //       contentData[i][key] = i;
    //     }
    //     this.addForm.content = contentData;
    //     // setTimeout(() => { 可能不需要了
    //     //   // this.html = Info.data.releaseNotes;
    //     //   // this.ht4ml = Info.data.drugName;
    //     // }, 100)
    //   } else {
    //     this.$message.error(Info.message);
    //   }
    },
    windowOpen(url) {
      window.open(url)
    },
    // 分页查询
    pageChange(page_no, page_size) {
      this.pagination.pageNum = page_no;
      this.pagination.pageSize = page_size;
      this.getTable();
    },
    // 删除
    async delBtn(id) {
      const response = await delVersion(id);
      if (response.code == 0) {
        this.getTable();
        this.$message.success("删除成功");
      } else {
        this.$message.warning(response.message);
      }
    },
    async onChange(id, open) {
      // console.log(id, open)
      const data = {
        id: id,
        status: open,
      };
      const Info = await putVersion(data);
      if (Info.code === 0) {
        this.getTable();
        this.$message.success("操作成功");
      } else {
        this.$message.error("操作失败" + Info.message);
      }
    },
    async on2Change(id, open) {
      // console.log(id, open)
      const data = {
        id: id,
        isForced: open,
      };
      const Info = await putVersion(data);
      if (Info.code === 0) {
        this.getTable();
        this.$message.success("操作成功");
      } else {
        this.$message.error("操作失败" + Info.message);
      }
    },
    // 重置
    returnBtn() {
      this.searchName = ""; //输入框
      this.pagination.current = 1; //默认显示
      this.pagination.pageSize = 10; //行数
      this.pagination.pageNum = 1;
      this.timeVal = []
      this.StartTime = ""
      this.EndTime = ""
    //   this.state = ""; //状态
    //   this.state = "";
      this.getTable();
    },
    // table列表
    async getTable() {
      let data = {
        versionName: this.searchName,
        createdStartDate: this.StartTime,
        createdEndDate: this.EndTime,
        pageNo: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      }
      const response = await getVersion(data);
      if (response.code === 0) {
        this.dataTable = response.data;
        this.pagination.total = response.count;
        // console.log("表", response.data);
      } else {
        this.$message.warning(response.message);
      }
    },
    // 日期
    async onChange_range_picker(date, dateString){
        // 重置页码
        this.pagination.pageNum = 1;
        this.pagination.pageSize = 10;
        this.pagination.current = 1;
        this.StartTime = dateString[0]
        this.EndTime = dateString[1]

        this.getTable();
    //   this.StartTime = dateString[0]
    //   this.EndTime = dateString[1]
    //   this.pageNo = 1
    //   this.pageSum = 10
    //   // this.id = this.menuList[0].id;
    //   let data = {
    //     typeId:this.id,
    //     beginDate: this.StartTime,
    //     endDate: this.EndTime,
    //     replyStatus: this.replyStatus,
    //     page: this.pageNo,
    //     pageSum: this.pageSum,
    //   };
    //   const res = await getErrSelectAll(data);
    //   if (res.code == 200) {
    //     this.messageList = res.data;
    //     this.total = res.count;
    //   //   console.log("数据啊",res.data)
    //   }
    },
    // 搜索框查询
    searchBtn() {
      // 重置页码
      this.pagination.pageNum = 1;
      this.pagination.pageSize = 10;
      this.pagination.current = 1;
      this.getTable();
    },
    // 新建
    async addOk() {
      // this.onCreated();
      //  console.log("表单",this.addForm)
      // if (this.addForm.releaseNotes == "<p><br></p>" || this.addForm.releaseNotes == "") {
      //   this.$message.error("请输入更新内容");
      //   return
      // }
      this.$refs.add.validate(async (valid) => {
        // 表单校验
        if (valid) {
          let data = {...this.addForm}
          data.status = data.status ? 'OPENED' : 'CLOSED'
          data.isForced = data.isForced ? 1 : 0
          if(!data.id){
            console.log("新增")
            const response = await postVersion(data);
            if (response.code === 0) {
              // 刷新首页数据
              this.getTable();
              this.$message.success("新增成功");
              this.addShow = false;
              this.addForm = {}
              //  this.html = '';
              //  this.ht4ml = '';
              //  this.addForm.releaseNotes = ''
              //  this.addForm.genericName = ''
              //  this.editor.destroy()
              //  this.editor = null
            } else {
              this.$message.error(response.message);
            }
            this.$refs.add.resetFields();
          }else{
            // console.log("修改")
            const response = await putVersion(data);
            if (response.code === 0) {
              // 刷新首页数据
              this.getTable();
              this.$message.success("修改成功");
              this.addShow = false;
              this.addForm = {}
              //  this.html = '';
              //  this.ht4ml = '';
              //  this.addForm.releaseNotes = ''
              //  this.addForm.genericName = ''
              //  this.editor.destroy()
              //  this.editor = null
            } else {
              this.$message.error(response.message);
            }
            this.$refs.add.resetFields();

          }
        } else {
          this.$message.error("请填写完整并保存");
        }
      });
    },
    editOk() {
    //   this.addForm.id = this.id;
    //   //  this.addForm.releaseNotes = this.html;
    //   //  this.addForm.drugName = this.ht4ml;
    //   this.onCreated();
    //   if (this.addForm.releaseNotes == "<p><br></p>") {
    //     this.addForm.releaseNotes = "";
    //   }
    //   //  删id
    //   for (var i = 0; i < this.addForm.detail.length; i++) {
    //     delete this.addForm.detail[i].id;
    //   }
    //   for (var i = 0; i < this.addForm.content.length; i++) {
    //     delete this.addForm.content[i].id;
    //   }
    //   this.addForm.detail = this.addForm.detail;
    //   this.addForm.content = this.addForm.content;
    //   console.log("修改表单", this.addForm);
    //   this.$refs.add.validate(async (valid) => {
    //     // 表单校验
    //     if (valid && this.btnContentType == "save" && this.btnType == "save") {
    //       const Info = await updateDrugs(this.addForm);
    //       if (Info.code === 0) {
    //         this.getTable();
    //         //  this.html = '';
    //         //  this.ht4ml = '';
    //         //  this.addForm.releaseNotes = ''
    //         //  this.addForm.genericName = ''
    //         //  this.editor.destroy()
    //         //  this.editor = null
    //         this.$message.success("修改成功");
    //       } else {
    //         this.$message.error("操作失败" + Info.message);
    //       }
    //       this.addShow = false;
    //       this.$refs.add.resetFields();
    //     } else {
    //       this.$message.error("请填写完整并保存");
    //     }
    //   });
    },
  }

}
</script>

<style lang="scss" scoped>
.datePicker {
  background-color: #fff;
  width: 100%;
  height: 64px;
  padding: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  position: relative;

  .status {
    float: right;
    position: absolute;
    right: 50px;
  }
}

::v-deep .ant-table-thead > tr > th {
  font-weight: bold;
}
.upload_File{
  width: 120px;
  border: 1px #DDDDDD solid;
  border-radius:4px;
  height: 32px;
  background-image: url("../../../assets/add_imgfile.png");
  background-size:80%;
  background-position:center center;
  background-repeat:no-repeat;
  cursor: pointer;
}
</style>